import {openDB} from 'idb';

import {
    extractEmail,
    MailFieldsForCache as MAILFieldsForCache,
    MailFieldsForCache,
    parseMessageForCache
} from "../mail/utils";
import StateManager from "../redux/StateManager";
import _ from "lodash";
import moment from "moment-timezone";
import {
    LOCAL_BOXES_CACHE_COLLECTION_NAME,
    INTERNAL_GROUPING_BOXES,
    LOCAL_BOXES_CACHE_INDEX_KEYS,
    UnReadFlag,
    ReadFlag,
    ACCOUNTS_INDEX_KEYS,
    ACCOUNTS_COLLECTION_NAME,
    CONTACTS_COLLECTION_NAME, CONTACTS_INDEX_KEYS
} from "../utils/constants";

function md5(string) {
    return string;
}

const internalGroupingBoxes = ["Trash"];


async function localDbExists() {
    const dbName = md5(StateManager.getUserEmail())
    try {
        const db = await openDB(dbName);
        db.close();
        return true;
    } catch (error) {
        return false;
    }
}

export async function listUserVisibleBoxesFromCache() {
    const dbName = md5(StateManager.getUserEmail());
    const collectionName = md5("boxes");

    const db = await openDB(dbName, StateManager.getIdbVersion());

    if (!db.objectStoreNames.contains(collectionName)) {
        return [];
    }

    const tx = db.transaction(collectionName, "readonly");
    const store = tx.objectStore(collectionName);

    let allBoxes = await store.getAll();
    await tx.done;


    allBoxes.sort((a, b) => (a.sortNumber || 0) - (b.sortNumber || 0));
    return allBoxes
}

export async function listUserVisibleBoxesFromCacheWithUnreadCount(intendedFor = "all") {
    const dbName = md5(StateManager.getUserEmail());
    const collectionName = md5("boxes");

    const db = await openDB(dbName, StateManager.getIdbVersion());

    if (!db.objectStoreNames.contains(collectionName)) {
        return [];
    }

    const tx = db.transaction(collectionName, "readonly");
    const store = tx.objectStore(collectionName);

    let allBoxes = await store.getAll();
    await tx.done;


    allBoxes.sort((a, b) => (a.sortNumber || 0) - (b.sortNumber || 0));

    for (let i = 0; i < allBoxes.length; i++) {
        allBoxes[i].totalUnread = await countBoxUnreadMessages(allBoxes[i].name, intendedFor);
    }

    return allBoxes
}

const countBoxUnreadMessages = async (box, intendedFor) => {
    const dbName = md5(StateManager.getUserEmail());
    const db = await openDB(dbName, StateManager.getIdbVersion());
    const tx = db.transaction(md5(box), 'readonly');
    const store = tx.objectStore(md5(box));
    const index = store.index("uid");
    const direction = "next"
    let cursor = await index.openCursor(null, direction);
    let count = 0
    while (cursor) {
        const msg = cursor.value;
        if (intendedFor !== "all") {
            if (msg.flags.includes("Recent") && msg.intendedFor === intendedFor) {
                count++
            }
        } else {
            if (msg.flags.includes("Recent")) {
                count++
            }
        }
        cursor = await cursor.continue();
    }

    await tx.done
    await db.close()
    return count

}


const boxesCollectionName = md5(LOCAL_BOXES_CACHE_COLLECTION_NAME);

export async function initMailsCacheDB(boxes) {
    const dbName = md5(StateManager.getUserEmail());
    const existingDatabases = await indexedDB.databases();
    const dbExists = existingDatabases.some((db) => db.name === dbName);
    if (dbExists) {
        console.log(`Database '${dbName}' already exists.`);
    }
    let collections = [];
    boxes.forEach((box) => {
        collections.push(md5(box.name));
    })
    collections.push(boxesCollectionName);
    let db = await openDB(dbName, StateManager.getIdbVersion(), {
        upgrade(db) {
            collections.forEach((boxName) => {
                if (!db.objectStoreNames.contains(boxName)) {
                    if (boxName !== boxesCollectionName) {
                        let store = db.createObjectStore(boxName, {keyPath: MailFieldsForCache.uid});
                        store.createIndex(MailFieldsForCache.uid, MailFieldsForCache.uid, {unique: true});
                        store.createIndex(MailFieldsForCache.from, MailFieldsForCache.from);
                        store.createIndex(MailFieldsForCache.timestamp, MailFieldsForCache.timestamp);
                        store.createIndex(MailFieldsForCache.threadId, MailFieldsForCache.threadId);
                        store.createIndex(MailFieldsForCache.intendedFor, MailFieldsForCache.intendedFor);
                        store.createIndex(MailFieldsForCache.internal, MailFieldsForCache.internal);
                    } else {
                        let store = db.createObjectStore(boxName, {keyPath: LOCAL_BOXES_CACHE_INDEX_KEYS.name});
                        store.createIndex(LOCAL_BOXES_CACHE_INDEX_KEYS.name, LOCAL_BOXES_CACHE_INDEX_KEYS.name, {unique: true});
                        store.createIndex(LOCAL_BOXES_CACHE_INDEX_KEYS.type, LOCAL_BOXES_CACHE_INDEX_KEYS.type);
                        store.createIndex(LOCAL_BOXES_CACHE_INDEX_KEYS.createdAt, LOCAL_BOXES_CACHE_INDEX_KEYS.createdAt);
                    }

                } else {
                    console.log(`Collection already added: ${boxName}`)
                }
            });

            let store = db.createObjectStore(ACCOUNTS_COLLECTION_NAME, {keyPath: ACCOUNTS_INDEX_KEYS.email})
            store.createIndex(ACCOUNTS_INDEX_KEYS.email, ACCOUNTS_INDEX_KEYS.email)
            store = db.createObjectStore(CONTACTS_COLLECTION_NAME, {keyPath: CONTACTS_INDEX_KEYS.email})
            store.createIndex(CONTACTS_INDEX_KEYS.email, CONTACTS_INDEX_KEYS.email)
        }
    });
    console.log(`Mails local collections added.`)
    await db.close()
}

export async function saveContacts(emails) {
    let db = await openDB(md5(StateManager.getUserEmail()), StateManager.getIdbVersion());
    const tx = db.transaction(CONTACTS_COLLECTION_NAME, 'readwrite');
    const store = tx.objectStore(CONTACTS_COLLECTION_NAME);
    for (let i = 0; i < emails.length; i++) {
        await store.put({email: emails[i]});
    }
    await tx.done;
    await db.close()
}

export async function saveAccountInCache(emails) {
    let db = await openDB(md5(StateManager.getUserEmail()), StateManager.getIdbVersion());
    const tx = db.transaction(ACCOUNTS_COLLECTION_NAME, 'readwrite');
    const store = tx.objectStore(ACCOUNTS_COLLECTION_NAME);
    for (let i = 0; i < emails.length; i++) {
        await store.put(emails[i]);
    }
    await tx.done;
    await db.close()
}

export async function fetchUserAccountsFromCache() {
    let db = await openDB(md5(StateManager.getUserEmail()), StateManager.getIdbVersion());
    const tx = db.transaction(ACCOUNTS_COLLECTION_NAME, 'readwrite');
    const store = tx.objectStore(ACCOUNTS_COLLECTION_NAME);
    let accounts = await store.getAll()
    await tx.done;
    await db.close()
    return accounts
}

export async function fetchContactsSuggestionsFromCache(searchString) {
    const dbName = md5(StateManager.getUserEmail());
    const db = await openDB(dbName, StateManager.getIdbVersion());
    const tx = db.transaction(CONTACTS_COLLECTION_NAME, 'readonly');
    const store = tx.objectStore(CONTACTS_COLLECTION_NAME);
    const index = store.index("email");
    const direction = "next"
    let cursor = await index.openCursor(null, direction);
    let results = []
    while (cursor) {
        const msg = cursor.value;
        if (msg.email.includes(searchString)) {
            results.push(msg.email)
        }
        cursor = await cursor.continue();
    }

    await tx.done
    await db.close()
    return results

}

export async function deleteMailsCacheDB() {
    const dbName = md5(StateManager.getUserEmail());
    return new Promise((resolve, reject) => {
        const deleteRequest = indexedDB.deleteDatabase(dbName);

        deleteRequest.onsuccess = function () {
            console.log(`Database '${dbName}' deleted successfully.`);
            resolve(true);
        };

        deleteRequest.onerror = function (event) {
            console.error(`Error deleting database '${dbName}':`, event.target.error);
            reject(event.target.error);
        };

        deleteRequest.onblocked = function () {
            console.warn(`Delete blocked for database '${dbName}'. Close all open connections.`);
            reject("Delete blocked. Please close all database connections.");
        };
    });
}


export async function addBoxesListInCache(boxes) {
    let db = await openDB(md5(StateManager.getUserEmail()), StateManager.getIdbVersion());
    const tx = db.transaction(boxesCollectionName, 'readwrite');
    const store = tx.objectStore(boxesCollectionName);
    for (let i = 0; i < boxes.length; i++) {
        await store.put(boxes[i]);
    }
    await tx.done;
    await db.close()
}

async function addBox(box) {
    let db = await openDB(md5(StateManager.getUserEmail()), StateManager.getIdbVersion());
    const tx = db.transaction(boxesCollectionName, 'readwrite');
    const store = tx.objectStore(boxesCollectionName);
    await store.put(box);
    await tx.done;
    await db.close()
}

export async function addNewBoxCollection(boxName) {
    const oldVersion = StateManager.getIdbVersion();
    const newVersion = oldVersion + 1;

    const dbName = md5(StateManager.getUserEmail());

    const db = await openDB(dbName, newVersion, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(boxName)) {
                const store = db.createObjectStore(boxName, {keyPath: MAILFieldsForCache.uid});
                store.createIndex(MailFieldsForCache.uid, MailFieldsForCache.uid, {unique: true});
                store.createIndex(MailFieldsForCache.from, MailFieldsForCache.from);
                store.createIndex(MailFieldsForCache.timestamp, MailFieldsForCache.timestamp);
                store.createIndex(MailFieldsForCache.threadId, MailFieldsForCache.threadId);
                store.createIndex(MailFieldsForCache.intendedFor, MailFieldsForCache.intendedFor);
            }
        }
    });

    await db.close()

    StateManager.setIdbVersion(newVersion);
}

export async function createNewBox(box) {
    console.log(`adding box, ${box.name}`)
    await addNewBoxCollection(box.name);
    await addBox(box)
}


export async function removeBoxCollection(boxName) {
    const oldVersion = StateManager.getIdbVersion();
    const newVersion = oldVersion + 1;

    const dbName = md5(StateManager.getUserEmail());

    const db = await openDB(dbName, newVersion, {
        upgrade(db) {
            if (db.objectStoreNames.contains(boxName)) {
                db.deleteObjectStore(boxName);
            }
        }
    });

    await db.close()

    StateManager.setIdbVersion(newVersion);
}

async function removeBox(boxName) {
    let db = await openDB(md5(StateManager.getUserEmail()), StateManager.getIdbVersion());
    const tx = db.transaction(boxesCollectionName, 'readwrite');
    const store = tx.objectStore(boxesCollectionName);
    await store.delete(boxName);
    await tx.done;
    await db.close()
}

export async function deleteBoxFromCache(boxName) {
    console.log(`deleting box, ${boxName}`);
    await removeBox(boxName)
    await removeBoxCollection(boxName)
}


export async function addEmailInCache(box, message) {

    const dbName = md5(StateManager.getUserEmail())
    box = md5(box)
    const db = await openDB(dbName, StateManager.getIdbVersion());
    const tx = db.transaction(box, 'readwrite');
    const store = tx.objectStore(box);
    await store.put(message);
    await tx.done;
    await db.close()

    let to = []
    let cc = []
    cc = parseRecipients(message.cc)
    if (extractEmail(message.from) === StateManager.getUserEmail()) {
        to = parseRecipients(message.to)
    } else {
        to = parseRecipients(message.from)
    }

    let main = to.concat(cc)
    console.log(`saving contacts`)
    console.log(main)
    await saveContacts(main)
}

export async function deleteMessageFromBox(box, uid) {
    const dbName = md5(StateManager.getUserEmail())
    box = md5(box)
    const db = await openDB(dbName, StateManager.getIdbVersion());
    const tx = db.transaction(box, 'readwrite');
    const store = tx.objectStore(box);
    await store.delete(uid);
    await tx.done
    await db.close()
}

async function getThreadSearchBoxes() {
    let allBoxes = await listUserVisibleBoxesFromCache()
    let resp = []
    allBoxes.forEach(box => {
        resp.push(box.name)
    })
    return resp
}

export async function fetchThreadFromCache(threadId) {

    let boxesToSearchThreads = await getThreadSearchBoxes()


    const dbName = md5(StateManager.getUserEmail());
    const db = await openDB(dbName, StateManager.getIdbVersion());

    const messages = [];

    const fetchFromStore = async (storeName) => {
        const tx = db.transaction(storeName, 'readonly');
        const store = tx.objectStore(storeName);
        const index = store.index("threadId");

        for await (const cursor of index.iterate(IDBKeyRange.only(threadId))) {
            messages.push(cursor.value);
        }
    };

    for (let i = 0; i < boxesToSearchThreads.length; i++) {
        await fetchFromStore(boxesToSearchThreads[i])
    }

    await db.close()
    return messages.sort((a, b) => moment.utc(b.createdAt).valueOf() - moment.utc(a.createdAt).valueOf());
}


export function listMessagesFromCache(box, pageNumber, pageSize, sortOption = 'date', ascending = false, intendedFor = 'all') {
    return listPaginatedThreadsByBox(box, pageNumber, pageSize, sortOption, ascending, intendedFor);
}

// export async function listPaginatedThreadsByBox(box, pageNumber, pageSize, sortOption = 'date', ascending = false, intendedFor = 'all') {
//
//     console.log(`Rendering listing using ${box}, page: ${pageNumber}, size: ${pageSize}, sort: ${sortOption}, ascending: ${ascending}, intendedFor: ${intendedFor}`);
//
//     let boxesToBuildThreads = await getThreadSearchBoxes(box, pageNumber, pageSize, sortOption, ascending, intendedFor);
//
//     console.log(boxesToBuildThreads);
//
//     const dbName = md5(StateManager.getUserEmail());
//     const db = await openDB(dbName, StateManager.getIdbVersion());
//     const boxStore = md5(box);
//     const direction = ascending ? 'next' : 'prev';
//     const threadOffset = (pageNumber - 1) * pageSize;
//     const seenThreadIds = new Set();
//     const resultMessages = [];
//
//     if (sortOption === "date") {
//         sortOption = "timestamp"
//     }
//
//     if (![...db.objectStoreNames].includes(boxStore)) {
//         console.error(`Store '${boxStore}' not found`);
//         throw new Error(`Store ${boxStore} not found`);
//     }
//
//     const tx = db.transaction(boxStore, 'readonly');
//     const store = tx.objectStore(boxStore);
//     const index = store.index(sortOption);
//
//     const allMessages = await index.getAll();
//     const filteredMessages = intendedFor === 'all'
//         ? allMessages
//         : allMessages.filter(msg => msg.intendedFor === intendedFor);
//
//     const uniqueThreadCount = new Set(filteredMessages.map(msg => msg.threadId)).size;
//     const totalPages = Math.ceil(uniqueThreadCount / pageSize);
//
//     let cursor = await index.openCursor(null, direction);
//     let skippedThreads = 0;
//
//     while (cursor && resultMessages.length < pageSize) {
//         const msg = cursor.value;
//
//         if (intendedFor !== 'all' && msg.intendedFor !== intendedFor) {
//             cursor = await cursor.continue();
//             continue;
//         }
//
//         if (!seenThreadIds.has(msg.threadId)) {
//             if (skippedThreads < threadOffset) {
//                 skippedThreads++;
//             } else {
//                 resultMessages.push(msg);
//             }
//             seenThreadIds.add(msg.threadId);
//         }
//         cursor = await cursor.continue();
//     }
//
//     const threadIds = resultMessages.map((msg) => msg.threadId);
//     const threadSizeMap = {};
//
//     await Promise.all(threadIds.map(async (id) => {
//         threadSizeMap[id] = await countThreadSizeFromOtherBoxes(db, id, boxesToBuildThreads, intendedFor);
//     }));
//
//     for (const msg of resultMessages) {
//         msg.threadSize = threadSizeMap[msg.threadId] || 1;
//         if (msg.flags.indexOf("Recent") < 0) {
//             if (await checkIfARecentMessageInThread(db, msg.threadId, box)) {
//                 msg.flags = ["Recent"];
//             }
//         }
//     }
//
//     await tx.done
//     await db.close()
//     return {
//         mails: resultMessages,
//         totalMessages: uniqueThreadCount,
//         pageNumber,
//         pageSize,
//         totalPages,
//         hasNext: pageNumber < totalPages,
//         hasPrevious: pageNumber > 1,
//         ascending,
//         sortOption,
//     };
// }

export async function listPaginatedThreadsByBox(box, pageNumber, pageSize, sortOption = 'date', ascending = false, intendedFor = 'all') {
    console.log(`Rendering listing using ${box}, page: ${pageNumber}, size: ${pageSize}, sort: ${sortOption}, ascending: ${ascending}, intendedFor: ${intendedFor}`);

    let boxesToBuildThreads = await getThreadSearchBoxes();

    const dbName = md5(StateManager.getUserEmail());
    const db = await openDB(dbName, StateManager.getIdbVersion());
    const boxStore = md5(box);
    const direction = ascending ? 'next' : 'prev';
    const threadOffset = (pageNumber - 1) * pageSize;
    const seenThreadIds = new Set();
    const resultMessages = [];

    if (sortOption === "date") sortOption = "timestamp";

    if (![...db.objectStoreNames].includes(boxStore)) {
        console.error(`Store '${boxStore}' not found`);
        throw new Error(`Store ${boxStore} not found`);
    }

    const tx = db.transaction(boxStore, 'readonly');
    const store = tx.objectStore(boxStore);
    const index = store.index(sortOption);

    const allMessages = await index.getAll();
    const filteredMessages = intendedFor === 'all'
        ? allMessages
        : allMessages.filter(msg => msg.intendedFor === intendedFor);

    const standaloneMessages = filteredMessages.filter(msg => msg.internal === true);
    const threadableMessages = filteredMessages.filter(msg => msg.internal !== true);

    const threadableThreadIds = new Set(threadableMessages.map(msg => msg.threadId));
    const uniqueThreadCount = threadableThreadIds.size + standaloneMessages.length;
    const totalPages = Math.ceil(uniqueThreadCount / pageSize);

    let cursor = await index.openCursor(null, direction);
    let skippedThreads = 0;

    while (cursor && resultMessages.length < pageSize) {
        const msg = cursor.value;

        if (intendedFor !== 'all' && msg.intendedFor !== intendedFor) {
            cursor = await cursor.continue();
            continue;
        }

        if (msg.internal === true) {
            if (skippedThreads < threadOffset) {
                skippedThreads++;
            } else {
                resultMessages.push(msg);
            }
            cursor = await cursor.continue();
            continue;
        }

        if (!seenThreadIds.has(msg.threadId)) {
            if (skippedThreads < threadOffset) {
                skippedThreads++;
            } else {
                resultMessages.push(msg);
            }
            seenThreadIds.add(msg.threadId);
        }

        cursor = await cursor.continue();
    }

    const threadIds = resultMessages.map(msg => msg.threadId);

    const threadSizeMap = {};
    await Promise.all(threadIds.map(async (id) => {
        threadSizeMap[id] = await countThreadSizeFromOtherBoxes(db, id, boxesToBuildThreads, intendedFor);
    }));

    for (const msg of resultMessages) {
        msg.threadSize = threadSizeMap[msg.threadId];
        if (!msg.internal && msg.threadSize > 1) {
            console.log(`message is a thread`)
            console.log(msg.flags)
            if (await checkIfARecentMessageInThread(db, msg.threadId, boxesToBuildThreads)) {
                console.log(`setting flags`)
                msg.flags = ["Recent"];
            }
        }
    }

    console.log(resultMessages)

    await tx.done;
    await db.close();

    return {
        mails: resultMessages,
        totalMessages: uniqueThreadCount,
        pageNumber,
        pageSize,
        totalPages,
        hasNext: pageNumber < totalPages,
        hasPrevious: pageNumber > 1,
        ascending,
        sortOption,
    };
}


async function countThreadSizeFromOtherBoxes(db, threadId, boxes, intendedFor = 'all') {
    const countFromStore = async (storeName) => {
        const tx = db.transaction(storeName, 'readonly');
        const store = tx.objectStore(storeName);
        const index = store.index('threadId');
        let count = 0;

        for await (const cursor of index.iterate(IDBKeyRange.only(threadId))) {
            const msg = cursor.value;
            if (intendedFor === 'all' || msg.intendedFor === intendedFor) {
                count++;
            }
        }
        return count;
    };

    let count = 0

    for (let i = 0; i < boxes.length; i++) {
        count += await countFromStore(boxes[i])
    }

    return count;
}

async function checkIfARecentMessageInThread(db, threadId, boxes) {
    let isRecent = false
    for (let i = 0; i < boxes.length; i++) {
        const box = boxes[i];
        const tx = db.transaction(box, 'readonly');
        const store = tx.objectStore(box);
        const index = store.index('threadId');
        for await (const cursor of index.iterate(IDBKeyRange.only(threadId))) {
            if (cursor.value.flags.indexOf("Recent") > -1) {
                return true
            } else {
                cursor.continue();
            }
        }
    }
    return isRecent
}


export async function readMessageByUid(box, uid) {
    try {
        const dbName = md5(StateManager.getUserEmail())
        box = md5(box)
        const db = await openDB(dbName, StateManager.getIdbVersion());
        const tx = db.transaction(box, 'readonly');
        const store = tx.objectStore(box);
        const message = await store.get(uid);
        await tx.done;
        await db.close()
        return message;
    } catch (e) {
        console.error(e)
        return {}
    }
}

export async function moveMessageInCache(messageList) {
    if (_.isEmpty(messageList)) {
        return
    }
    for (let i = 0; i < messageList.length; ++i) {
        let msg = messageList[i];
        const uid = msg.uid;

        console.log(`trying to move message: ${messageList[i].uid} from: ${messageList[i].from} to: ${messageList[i].to}`);

        let message = await readMessageByUid(msg.from, uid)
        if (_.isEmpty(message)) {
            continue
        }
        message.box = msg.to
        await addEmailInCache(msg.to, message)
        await deleteMessageFromBox(msg.from, uid)
    }
}

export async function markMessageInCache(messageList) {
    console.log(`marking message`, messageList)
    if (_.isEmpty(messageList)) {
        return
    }
    for (let i = 0; i < messageList.length; ++i) {
        const {uid, flag, box} = messageList[i]
        let message = await readMessageByUid(box, uid)
        if (_.isEmpty(message)) {
            continue
        }
        message.flags = [flag]
        await addEmailInCache(box, message)
    }
}

export async function copyMessageInCache(messageList) {
    for (let i = 0; i < messageList.length; ++i) {
        let copyObject = messageList[i];
        const message = await readMessageByUid(copyObject.from, copyObject.uid)
        if (_.isEmpty(message)) {
            continue
        }
        message.uid = copyObject.newUid
        message.box = copyObject.to
        message.messageId = copyObject.newMessageId
        message.threadId = copyObject.newThreadId
        await addEmailInCache(copyObject.to, message)
    }
}

export async function parseAndAddEmailInCache(box, mailObject) {
    let parsed = await parseMessageForCache(box, mailObject)
    return addEmailInCache(parsed.box, parsed.cacheObject)
}

export async function updateCache(messageFromBackend) {
    if (!await localDbExists()) {
        return
    }
    const {message, eventType} = messageFromBackend
    switch (eventType) {
        case "newMessage":
            return parseAndAddEmailInCache(message.box, message)
        case "messageCopied":
            return copyMessageInCache(message.messageList)
        case "messageDeleted":
            return deleteMessagesFromCache(message.messageList)
        case "messageMarked":
            return markMessageInCache(message.messageList)
        case "messageMoved":
            return moveMessageInCache(message.messageList)
        case "boxCreated":
            return createNewBox(message)
        case "boxDeleted":
            return deleteBoxFromCache(message.name)
        case "aliasAdded":
            return saveAccountInCache([{email: message.email}])
        default:
            break;
    }
}

export async function deleteMessagesFromCache(messageList) {
    for (let i = 0; i < messageList.length; ++i) {
        let msg = messageList[i];
        const uid = msg.uid;
        await deleteMessageFromBox(msg.box, uid)
    }
}


export async function getSearchPaginatedResults(box, searchWords, pageNumber = 1, pageSize = 7, sortOption = "uid", ascending = false) {
    const dbName = md5(StateManager.getUserEmail())
    const storeName = md5(box)
    const db = await openDB(dbName, StateManager.getIdbVersion());
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);
    let direction = ""
    let filteredRecords = []
    const offset = (pageNumber - 1) * pageSize;
    let skipped = 0;
    if (ascending) {
        direction = "next"
    } else {
        direction = "prev"
    }

    let cursor = await store.index(sortOption).openCursor(null, direction);
    while (cursor && filteredRecords.length < pageSize) {
        if (skipped < offset) {
            skipped++;
        } else {
            const msg = cursor.value;
            let words = msg.words.split(",")
            searchWords.forEach((word) => {
                if (words.indexOf(word) > -1) {
                    filteredRecords.push(msg);
                }
            })
        }
        cursor = await cursor.continue();
    }


    const totalResults = filteredRecords.length;
    const totalPages = Math.ceil(totalResults / pageSize);
    const hasPrevious = pageNumber > 1;
    const hasNext = pageNumber < totalPages;
    const startIndex = (pageNumber - 1) * pageSize;
    let paginatedRecords
    if (hasPrevious || hasNext) {
        paginatedRecords = filteredRecords.slice(startIndex, startIndex + pageSize);
    } else {
        paginatedRecords = filteredRecords
    }

    await db.close()

    return {
        mails: paginatedRecords,
        hasNext,
        hasPrevious,
        totalPages,
        pageNumber,
    };
}

export async function getLastUidOfBox(box) {
    const dbName = md5(StateManager.getUserEmail());
    const storeName = md5(box);
    const db = await openDB(dbName, StateManager.getIdbVersion());
    if (!db.objectStoreNames.contains(storeName)) {
        console.warn(`Store ${storeName} does not exist in DB.`);
        return 0;
    }
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    const index = store.index('uid');
    const cursor = await index.openCursor(null, 'prev');

    if (cursor) {
        return cursor.value.uid;
    }

    await db.close()

    return null;
}

function parseRecipients(input) {
    const emailRegex = /[\w.-]+@[\w.-]+\.\w+/g;
    const matches = input.match(emailRegex) || [];
    return matches.filter(email => !email.endsWith('ext.privmail.com'));
}




